module.exports = __webpack_public_path__ + "img/scan.9a75620b.svg";